module.exports = __webpack_public_path__ + "static/media/zappertak-5.aaefa10e.jpg";